// extracted by extract-css-chunks-webpack-plugin
module.exports = {"icon":"_2MUBf_","popover":"_2kr_VJ"};